Core.SharedRouter = Core.SubRouter.extend({
    routes: {
        'job': 'job',
        'order': 'order',
        'form': 'form',
        'reservation': 'reservation',
        '*fallback': 'fallback',
    },

    job: function () {
        debug.log('shared job');
        app.setMainView(new JobDetailsView({ sharedView: true, customerView: typeof Core.param('customer') !== 'undefined' }));
    },

    order: function () {
        debug.log('shared order');
        app.setMainView(new OrderDetailsView({ sharedView: true, customerView: typeof Core.param('customer') !== 'undefined' }));
    },

    form: function () {
        debug.log('shared form');
        app.setMainView(new FormDetailsView({ sharedView: true, customerView: typeof Core.param('customer') !== 'undefined' }));
    },

    reservation: function () {
        debug.log('shared reservation');
        app.setMainView(new ReservationDetailsView({ sharedView: true, customerView: typeof Core.param('customer') !== 'undefined' }));
    },

    execute: function (callback, args, name) {
        Core.setupTokens(null, Core.param('access_token'));
        if (callback) callback.apply(this, args);
    },

});
